import { TextField } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useField } from 'react-final-form';
import dayjs from 'dayjs';

export const MonthPickerAdapter = ({
  input: { name, value },
  disableOpenPicker,
  disabled,
  noFuture,
  setValue,
  ...rest
}: any) => {
  const { input, meta } = useField(name);

  const onChange = (newValue) => {
    if (newValue) {
      const formattedValue = newValue.format('YYYY-MM'); // Solo Anno-Mese
      input.onChange(formattedValue);
      if (setValue) setValue(newValue);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        views={['year', 'month']}
        onChange={onChange}
        value={value ? dayjs(value) : null}
        disableFuture={noFuture ?? false}
        inputFormat="MM/YYYY"
        disableOpenPicker={disableOpenPicker ?? false}
        disabled={disabled ?? false}
        renderInput={(params) => (
          <TextField
            {...params}
            {...rest}
            helperText={meta.touched ? meta.error : ''}
            error={meta.error && meta.touched}
            fullWidth
          />
        )}
      />
    </LocalizationProvider>
  );
};
